import * as React from "react";

import { BirthdayPartyCelebration } from "Components/Shared/Icons";
import { Modal } from "@material-ui/core";
import { SecondaryButton } from "Components/Shared/Buttons/SecondaryButton";
import styled from "styled-components";

type Props = {
  name: string;
  open: boolean;
  onClose: () => void;
};

const StyledWrapperModal = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  & > div {
    &:first-of-type {
      background-color: rgba(255, 255, 255, 0.8) !important;
    }
  }

  .modal-body {
    outline: none;
    width: 100%;
    height: 100%;
    margin: auto;

    @media (max-width: 1199px) {
      max-width: calc(100% - 20px);
    }
  }

  .modal-body-content {
    outline: none;
    background-color: #fff;
    border: 1px solid ${props => props.theme.colors.border};
    box-shadow: ${props => props.theme.shadow.primary};
    width: 100%;
    height: 100%;
    margin: auto;
    position: relative;
    padding: 40px 20px;
    min-width: 430px;

    @media (max-width: 499px) {
      min-width: 1px;
    }
  }

  .modal-btns-block {
    > button {
      &:last-of-type {
        position: absolute;
        top: 5px;
        right: 5px;
        padding: 0;
        width: 30px;
        height: 30px;
        box-shadow: none;
        border: 0;
        margin-right: 0;

        &::after,
        &::before {
          content: "";
          position: absolute;
          top: 0;
          bottom: 0;
          margin: auto;
          width: 20px;
          height: 2px;
          background-color: ${props => props.theme.palette.primary.main};
        }

        &::after {
          transform: rotate(45deg);
        }
        &::before {
          transform: rotate(-45deg);
        }
      }
    }
  }

  .modal-text {
    text-align: center;

    h2 {
      font-size: 22px;
      line-height: 25px;
      font-weight: 400;
      margin: 0;
    }

    p {
      margin: 0;
      margin-top: 15px;
      line-height: 16px;
      font-weight: 400;
      color: rgb(109, 114, 120);

      @media (max-width: 499px) {
        br {
          display: none;
        }
      }
    }
  }
`;

const StyledImageWrapper = styled.div`
  margin-bottom: 20px;
  text-align: center;
  height: 70%;
  max-height: 260px;

  svg {
    max-width: 100%;
    max-height: 100%;
  }
`;

const StyledBody = styled.div`
  padding: 0;
  max-height: calc(100vh - 40px);
  outline: none !important;
  display: flex;
  flex-direction: column;
`;

const StyledBtnsWrapper = styled.div`
  display: flex;
  align-items: center;

  & > * {
    &:first-of-type {
      margin-right: ${props => props.theme.spacing(3)}px;
    }
  }
`;

export const ReminderModal: React.FunctionComponent<Props> = props => {
  const { name, open, onClose } = props;

  return (
    <StyledWrapperModal open={open} onClose={onClose}>
      <StyledBody className={"modal-wrapper"}>
        <div className="modal-body">
          <div className="modal-body-content">
            <StyledImageWrapper>
              <BirthdayPartyCelebration />
            </StyledImageWrapper>
            <div className="modal-text">
              <h2>
                Všechno nejlepší
                <br />k narozeninám, {name}!
              </h2>
              <p>
                Dnešní den jsi hvězda Ty! Přejeme mnoho splněných přání,
                <br />
                lásku, zdraví a&nbsp;pohodu. Užij si svůj narozeninový den!
              </p>
            </div>
            <StyledBtnsWrapper className={"modal-btns-block"}>
              <SecondaryButton onClick={onClose}></SecondaryButton>
            </StyledBtnsWrapper>
          </div>
        </div>
      </StyledBody>
    </StyledWrapperModal>
  );
};
